import * as yup from "yup";

export type EditEmissionsSourceFormValues = {
    name: string;
    uniqueReference: string;
    locationId: number;
    categoryId: number;
    typeId: number;
    itemId: number;
    portfolioId: number;
    sectorId: number;
    enterpriseValue: number;
    outstandingAmount: number;
};

export const editEmissionsSourceValidationFields = (
    uniqueReferenceIsUnique: (
        uniqueReference: string,
        id: number
    ) => Promise<boolean>,
    id: number
) => ({
    name: yup.string().required("Please enter a data source name"),
    uniqueReference: yup
        .string()
        .required("Please enter a data source unique reference")
        .test(
            "uniqueReference",
            "This unique reference is already being used.",
            async (value) => {
                if (!value) return true;
                return await uniqueReferenceIsUnique(value, id);
            }
        ),
    locationId: yup.number().required().moreThan(0, "Please select a location"),
    categoryId: yup.number().required().moreThan(0, "Please select a category"),
    typeId: yup.number().required().moreThan(0, "Please select a type"),
    itemId: yup.number().required().moreThan(0, "Please select an item"),
    portfolioId: yup.number().required().moreThan(0, "Please select a portfolio"),
    sectorId: yup.number().required().moreThan(0, "Please select a sector"),
    enterpriseValue: yup.number().required(),
    outstandingAmount: yup.number().required()
});
